import React, { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { getOneInvoiceAction } from "../../store/eventManagement/actions";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import jsPDF from "jspdf";
import { myEventActions } from "../../store/eventManagement";

const format = "ddd, Do MMM, YYYY";

const InvoicePDF = () => {
  const { eventManagement } = useSelector((state) => state);
  const dispatch = useDispatch();
  const pdfRef = useRef();
  const { paymentId } = useParams();
  const myInvoice = eventManagement?.selectedInvoice;

  useEffect(() => {
    dispatch(myEventActions.setCompletedPayment(null));
  }, [dispatch]);

  useEffect(() => {
    if (paymentId) {
      getOneInvoiceAction(paymentId)(dispatch);
    }
  }, [paymentId, dispatch]);

  const handleDownloadPdf = async () => {
    if (!pdfRef.current) {
      console.error("PDF content is not available");
      return;
    }

    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const padding = 10;

    pdf.html(pdfRef.current, {
      callback: function (pdf) {
        pdf.save(`${myInvoice?.booking?.event?.title}.pdf`);
      },
      x: padding,
      y: padding,
      width: pageWidth - 4 * padding,
      html2canvas: {
        scale: 0.2,
      },
    });
  };

  return (
    <div className="min-h-[calc(100vh-97px)] pt-16">
      <div
        className="max-w-4xl mx-auto bg-white dark:bg-primary-darkBg rounded-lg shadow-md pb-6"
        ref={pdfRef}
      >
        <header className="flex justify-between items-center bg-gray-800 dark:bg-[#1a1d1f] p-4 rounded-t-lg">
          <div className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center text-white font-bold">
              C
            </div>
            <h4 className="text-white">Company</h4>
          </div>
          <button
            className="bg-primary text-white font-bold py-2 px-8 rounded-lg text-center"
            onClick={handleDownloadPdf}
          >
            Download
          </button>
        </header>
        <section className="px-6 pt-4">
          <h2 className="text-2xl font-semibold mb-2">Invoice</h2>
          <div className="flex justify-between mb-2">
            <div>
              <p className="mb-2">
                Event:{" "}
                <span className="font-semibold dark:text-white">
                  {myInvoice?.booking?.event?.title}
                </span>
              </p>
              <p className="mb-2">
                Start Time:{" "}
                <span className="font-semibold dark:text-white">
                  {myInvoice?.booking?.event?.time_start}
                </span>
              </p>
              <p className="mb-2">
                Date:{" "}
                <span className="font-semibold dark:text-white">
                  {myInvoice && myInvoice?.booking?.event?.date
                    ? moment(myInvoice?.booking?.event?.date).format(format)
                    : ""}
                </span>
              </p>
            </div>
            <div>
              <p className="mb-2">
                Invoice ID:{" "}
                <span className="font-semibold dark:text-white">
                  {myInvoice?.transactionId}
                </span>
              </p>
              <p className="mb-2">
                Order Date:{" "}
                <span className="font-semibold dark:text-white">
                  {myInvoice && myInvoice?.createdAt
                    ? moment(myInvoice?.createdAt).format(format)
                    : ""}
                </span>
              </p>
              <p className="mb-2"></p>
            </div>
          </div>
        </section>

        {/* Event Details Table */}
        <div className="px-6 mt-6">
          <table className="w-full border-t border-b">
            <thead>
              <tr className="text-left">
                <th className="py-2">#</th>
                <th className="py-2">Ticket Category</th>
                <th className="py-2">Qty</th>
                <th className="py-2">Unit Price($)</th>
                <th className="py-2">Total($)</th>
              </tr>
            </thead>
            <tbody>
              {myInvoice?.booking?.tickets?.map((el, index) => (
                <tr>
                  <td className="py-2">{index + 1}</td>
                  <td className="py-2">{el?.ticket?.type}</td>
                  <td className="py-2">{el?.quantity}</td>
                  <td className="py-2">
                    {el?.ticket?.price?.toLocaleString()}
                  </td>
                  <td className="py-2">
                    {(el?.quantity * el?.ticket?.price)?.toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="flex justify-end mt-4">
            <h4>{`Total: ${myInvoice?.amount?.toLocaleString()}$`}</h4>
          </div>
          <p className="text-right text-sm text-gray-500">{`Paid via ${myInvoice?.method}`}</p>
        </div>
      </div>
    </div>
  );
};

export default InvoicePDF;
